<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 v-if="role == 'admin'" class="page-title">Timesheet List</h3>
          <h3 v-else class="page-title">My Staff Timesheet List</h3>
        </div>
        <div style="display: none" class="col-auto float-right ml-auto" v-if="role == 'admin'">
          <button class="btn add-btn">
            <i class="fa fa-plus"></i>New Timesheet
          </button>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Table List -->
    <div class="row">
      <div class="col-md-12">
        <!-- Form -->
        <div>
          <div class="row align-items-center">
            <div class="col-md-2">Company</div>
            <div class="col-md-4 pl-md-0">
              <select class="custom-select" v-model="company" @change="changeCompany">
                <option
                  v-for="(item, i) in companies"
                  :key="i"
                  :value="item.CompanyName"
                >
                  {{ item.CompanyName }}
                </option>
              </select>
            </div>
            <div class="col-md-2 ml-md-4">Department</div>
            <div class="col-md-3 pl-md-0">
              <select class="custom-select" v-model="department">
                <option value="">All</option>
                <option v-for="item in departments" :key="item.Department" :value="item.Department">
                  {{ item.Department }}
                </option>
              </select>
            </div>
          </div>

          <div class="row align-items-center mt-2">
            <div class="col-md-2">Employee Name/ID</div>
            <div class="col-md-4 pl-md-0">
              <Select2
                v-model="userId"
                :options="employees"
              />
            </div>
            <div class="col-md-2 ml-md-4">Status</div>
            <div class="col-md-3 pl-md-0">
              <select class="custom-select" v-model="status">
                <option value="">ALL</option>
                <option value="NEW">NEW</option>
                <option value="DRAFT">DRAFT</option>
                <option value="PENDING">PENDING</option>
                <option value="APPROVED">APPROVED</option>
                <option value="REJECTED">REJECTED</option>
              </select>
            </div>
          </div>

          <div class="row align-items-center mt-2">
            <div class="col-md-2">Month</div>
            <div class="col-md-2 pl-md-0">
              <select class="custom-select" v-model="month">
                <option value="">All</option>
                <option v-for="month in months" :key="month" :value="month">
                  {{ month }}
                </option>
              </select>
            </div>

            <div class="col-md-2"></div>
            
            <div class="col-md-2 ml-md-4">Year</div>
            <div class="col-md-2 pl-md-0">
              <select class="custom-select" v-model="year">
                <option v-for="year in years" :key="year" :value="year">
                  {{ year }}
                </option>
              </select>
            </div>
          </div>

          <div class="row align-items-center mt-3">
            <div class="col-md-12 text-center">
              <button type="submit" class="btn btn-primary" @click="search">Search</button>
            </div>
          </div>
        </div>
        <!-- /Form -->

        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1 mt-4">
          
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="text-center action-column">Action</th>
                <th class="group-column">Emp ID</th>
                <th>Emp Name</th>
                <th>Month</th>
                <th>Year</th>
                <th>Status</th>
                <th>Remarks</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(timesheet, index) in timesheets">
                <td class="action-column text-center">
                  <router-link
                    :to="{ name: 'timesheetView', params: { id: timesheet.Id } }"
                  >
                    <a class="btn btn-secondary"><span>View</span></a>
                  </router-link>
                </td>
                <td class="group-column">{{ timesheet.EmployeeID }}</td>
                <td class="group-column">{{ timesheet.EmployeeName }}</td>
                <td class="group-column">{{ timesheet.Month }}</td>
                <td class="group-column">{{ timesheet.Year }}</td>
                <td class="group-column">{{ timesheet.Status }}</td>
                <td class="group-column">{{ timesheet.Remarks }}</td>
              </tr>
              
              <tr v-if="timesheets && !timesheets.length">
                <td colspan="7" class="text-center">{{ this.noRecordText }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";

export default {
  data() {
    return {
      timesheets: null,
      month: "",
      year: "",
      company: "",
      department: "",
      userId: "All",
      months: [],
      years: [],
      companies: [],
      departments: [],
      employees: [],
      status: config.TIMESHEET_STATUS_DRAFT,
      noRecordText: config.NO_RECORD_TEXT,
      
      //for pagination
      paging: {
        Search: "",
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
        SortBy: "",
      },
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
    isManager(){
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.IsManager;
    }
  },

  methods: {
    getManagerEmployees() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      let param = { Token: this.token, IsActive: true, ManagerID: data.EmployeeID, Company: this.company };
      this.$store.state.isLoading = true;
      API.getManagerEmployees(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.employees = response.data.record;
            this.employees.unshift({ id: "All", text: "All" });
            this.employee = "All";
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getEmployees() {
      let param = { Token: this.token, Company: this.company };
      this.$store.state.isLoading = true;
      API.getEmployees(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.employees = response.data.record;
            this.employees.unshift({ id: "All", text: "All" });
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
            console.log(error);
            this.$store.state.isLoading = false;
            this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    changeCompany() {
      if(this.isManager) this.getManagerEmployees();
      else this.getEmployees();

      // do a search
      this.search();
    },
    getCompanies() {
      let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getAllCompanies(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.companies = response.data.record;

            this.company = this.companies[0].CompanyName;
            this.changeCompany();
            // console.log(this.companies);
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getDepartments() {
      let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getDepartments(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.departments = response.data.record;

            // console.log(this.departments);
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getYears() {
        let date = new Date();
        let minYear = date.getFullYear() - 5;
        this.years = [];
        for ( let year = date.getFullYear(); year > minYear; year-- ) {
            this.years.push(year);
        }
    },
    getMonths() {
        this.months = [];
        this.month = "";
        
        this.months.push("Jan");
        this.months.push("Feb");
        this.months.push("Mar");
        this.months.push("Apr");
        this.months.push("May");
        this.months.push("Jun");
        this.months.push("Jul");
        this.months.push("Aug");
        this.months.push("Sep");
        this.months.push("Oct");
        this.months.push("Nov");
        this.months.push("Dec");
    },
    getManagerTimesheet() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      let param = {
        Token: this.token,
        UserID: data.Id
      };
      this.$store.state.isLoading = true;
      API.getManagerTimesheet(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            if ( response.data.isEmpty ) {
              this.timesheets = [];
            }
            else {
              this.timesheets = response.data.record;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.message, { icon: "error" });
        });
    },
    search() {
      let param = {
        Token: this.token,
        Company: this.company,
        Department: this.department,
        UserID: this.userId != "All" ? this.userId : "",
        Status: this.status,
        Month: this.month,
        Year: this.year
      };
      this.$store.state.isLoading = true;
      API.searchTimesheet(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            if ( response.data.isEmpty ) {
              this.timesheets = [];
            }
            else {
              this.timesheets = response.data.record;

              for ( let index in this.timesheets ) {
                let timesheet = this.timesheets[index];
                let name = timesheet.CreatedBy;
                name = name.substring(name.indexOf("-") + 1);

                this.timesheets[index].Name = name;
              }
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    }
  },

  created() {
    // if ( this.role == "admin" ) {
    //   this.getMonths();
    //   this.getYears();

    //   let date = new Date();
    //   this.month = this.months[date.getMonth()];
    //   this.year = date.getFullYear();

    //   this.getCompanies();
    //   this.getDepartments();
    // }
    // else {
    //   this.getManagerTimesheet();
    // }
    this.getMonths();
    this.getYears();
    let date = new Date();
    this.month = this.months[date.getMonth()];
    this.year = date.getFullYear();
    this.getCompanies();
    this.getDepartments();
  },
};
</script>

<style scoped>
.group-column {
  width: 12%;
}
</style>


// WEBPACK FOOTER //
// src/components/Attendance/List.vue